<app-widget titleT="FIDUCIARY.cockpit.task-widget.title" [navigateLink]="navigateLink"
    [itemsCount]="(tasks$ | async)?.length" [loading]="(loadingService.loading$ | async)!">
    <div *appShowAuthorize="'APP_TASKS_WRITE'" class="slot-action-button">
        <app-button-icon-add (click)="navigation.navigateCreateTask(customerSpaceId)" />
    </div>
    <app-task-widget-table [tasks$]="tasks$" [displayRowsCount]="displayRowsCount"
        [customerSpaceId]="customerSpaceId" />
    <a *ngIf="showAll$ | async" [routerLink]="navigateLink" class="slot-footer">{{
        'FIDUCIARY.cockpit.task-widget.show-all-link' | translate }}</a>
</app-widget>